import { streamQuantityEventName } from '@/components/commonComponents/ExportByColumnModal';
import {
  DefaultEntity,
  SequencingBatchEntity,
  SequencingBatchParams,
} from '@/types';
import APIService from './axios.service';
import { BaseService } from './base.service';

class BatchService extends BaseService<
  'batch',
  SequencingBatchEntity,
  DefaultEntity
> {
  constructor() {
    super('batches');
  }

  streamSequencingBatch = (params: SequencingBatchParams): Promise<any> => {
    return APIService.get('/batches/stream-sequencing-batch', {
      params,
      responseType: 'stream',
      onDownloadProgress(data) {
        const responseData = data.event?.target?.response || '';
        // Regex to find all progress values
        const regex = /"progress"\s*:\s*(\d+(\.\d+)?)/g;
        const matches = [...responseData.matchAll(regex)];
        // Get the last match
        const lastMatch = matches[matches.length - 1];
        const lastProgress = lastMatch
          ? Math.round(parseFloat(lastMatch[1]))
          : 0;

        // Dispatch kit quantity for percent progress bar
        window.dispatchEvent(
          new CustomEvent(streamQuantityEventName, {
            detail: { percentProgress: lastProgress },
          }),
        );
      },
    });
  };
}

export const batchService = new BatchService();
